/**
 * Reporta las métricas web vitales a una función de callback
 * @param {Function} onPerfEntry - Función callback para procesar las métricas
 * @returns {void}
 */
const reportWebVitals = onPerfEntry => {
  if (!onPerfEntry || !(onPerfEntry instanceof Function)) {
    return;
  }

  import('web-vitals')
    .then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      try {
        getCLS(onPerfEntry);
        getFID(onPerfEntry);
        getFCP(onPerfEntry);
        getLCP(onPerfEntry);
        getTTFB(onPerfEntry);
      } catch (error) {
        console.error('Error al procesar métricas:', error);
      }
    })
    .catch(error => {
      console.error('Error al cargar web-vitals:', error);
    });
};

export default reportWebVitals;
